<script>
import PictureLazy from '@maison/components/common/PictureLazy.vue';
import StoreCardMixin from '@phoenix/mixins/components/store/storeCardMixin';
import { PhxIcon } from '@phx-styleguides/rdu';

export default {
  components: {
    PictureLazy,
    PhxIcon,
  },

  mixins: [StoreCardMixin],

  props: {
    socialLinks: {
      type: Array,
      default: () => [],
      required: false,
    },
  },

  computed: {
    getStoreCardClasses() {
      return [{ 'store-card--light': this.isReseller }, 'store-card'];
    },

    buttonClasses() {
      return ['sgphx-btn', 'sgphx-btn--primary', { 'sgphx-btn--positive': this.isReseller }];
    },
  },
};
</script>

<template>
  <div :class="getStoreCardClasses">
    <div class="store-card__media">
      <picture-lazy v-if="image" v-bind="image" img-class="store-card__image img-block" />
    </div>

    <div class="store-card__body">
      <a v-if="permalink" :href="permalink" class="h5 expand-target mb-1">{{ title }}</a>
      <a v-else href="" class="h5 expand-target mb-1">{{ title }}</a>

      {{ address }}
      <p v-if="status && !isReseller" class="pt-4 pb-1 font-bold">{{ status }}</p>

      <ul class="store-card__actions pt-4 pb-2" role="presentation">
        <li v-if="phone" class="p-2">
          <div class="sgphx">
            <a
              :href="`tel:${phone.replace(/\s/g, '')}`"
              :class="buttonClasses.concat(['sgphx-btn--icon'])"
              :title="$t('Styleguide.store-locator.call-boutique')"
              :aria-label="$t('Styleguide.store-locator.call-boutique')"
            >
              <span class="sgphx-btn__icon sgphx-btn__icon--start">
                <phx-icon icon="phone" class="sgphx-icon sgphx-icon--phone-16 sgphx-icon--sm" />
              </span>
              <span class="sgphx-btn__text">
                <span dir="ltr">{{ phoneLabel || phone }}</span>
              </span>
            </a>
          </div>
        </li>

        <li v-if="permalink" class="p-2">
          <div class="sgphx">
            <a :href="permalink" :target="isOnline ? '_blank' : null" :class="buttonClasses">
              <span class="sgphx-btn__text">
                <span>{{ seeMoreLabel }}</span>
              </span>
            </a>
          </div>
        </li>
      </ul>

      <ul class="store-card__actions" role="presentation">
        <li
          v-for="(socialLink, index) in socialLinks"
          :key="`${socialLink.link}-${index}`"
          class="py-1 px-2"
          role="presentation"
        >
          <div class="sgphx">
            <a :href="socialLink.link" class="sgphx-btn--icon-only sgphx-btn--icon" :title="socialLink.title">
              <span class="sgphx-btn__icon sgphx-btn__icon--start">
                <phx-icon
                  :icon="socialLink.network"
                  :class="`sgphx-icon sgphx-icon--${socialLink.network} sgphx-icon--sm`"
                />
              </span>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
